import { forwardRef, Fragment } from "react";
import Box from "@mui/material/Box";
import classes from "./PrintContent.module.css";
import Typography from "@mui/material/Typography";
import {
  DateField,
  RecordContextProvider,
  // usePermissions,
} from "react-admin";
import splitArrayToChunks from "../../../utils/splitArrayToChunks";

const PrintContent = forwardRef((props, ref) => {
  // eslint-disable-line max-len
  // const { permissions, isLoading } = usePermissions();

  return (
    <Box
      component="div"
      sx={{
        display: "none",
      }}
    >
      <Box ref={ref}>
        <style type="text/css" media="print">
          {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
              break-after: page;
              height: 0;
            }
            .page-break:last-child {
              page-break-after: auto;
              break-after: auto;
            }
            .big-back::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-image: url('/atena-tiles.png');
              background-repeat: no-repeat;
              background-position: 50% 19%;
              background-size: 20% auto;
              opacity: 0.2;
              z-index: -1;
            }
          `}
        </style>

        {splitArrayToChunks(props.record.sale_items, 5).map((arr, i, ori) => {
          // TODO semua print content strukturnya perlu ikutin ini
          const totalMutation = arr.reduce(
            (total, item) => total + Number(item.sent_quantity || 0),
            0
          );
          return (
            <Fragment key={i}>
              <Box
                className="big-back"
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  fontSize: "12px",
                  py: 2,
                  px: 2,
                  display: "flex",
                  flexDirection: "column",
                  height: "139.7mm",
                  boxSizing: "border-box",
                  fontFamily: "Arial, Helvetica, sans-serif",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    mb: 1,
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  {props.record.company.name}
                </Typography>
                <table className={classes.headerSj}>
                  <thead>
                    <tr>
                      <th style={{ width: "10%" }}>Kepada Yth</th>
                      <th>:</th>
                      <th style={{ width: "60%" }}>
                        {
                          props.record.sale_items[0].sale_order_item.sale_order
                            .customer.name
                        }
                      </th>
                      <th style={{ width: "15%" }}>No. Surat Jalan</th>
                      <th>:</th>
                      <th style={{ width: "15%" }}>{props.record.code}</th>
                    </tr>
                    <tr>
                      <th
                        rowSpan={2}
                        style={{ paddingTop: "3px", verticalAlign: "baseline" }}
                      >
                        Alamat
                      </th>
                      <th
                        rowSpan={2}
                        style={{ paddingTop: "3px", verticalAlign: "baseline" }}
                      >
                        :
                      </th>
                      <th
                        rowSpan={2}
                        style={{ paddingTop: "3px", verticalAlign: "baseline" }}
                      >
                        <span style={{ textTransform: "uppercase" }}>
                          {props.record.sale_items[0].sale_order_item.sale_order
                            .customer_address.detail +
                            ", " +
                            props.record.sale_items[0].sale_order_item
                              .sale_order.customer_address.city.name}
                        </span>
                      </th>
                      <th>Tgl. Pengiriman</th>
                      <th>:</th>
                      <th>
                        <RecordContextProvider value={props.record}>
                          <DateField
                            source="date"
                            sx={{
                              fontWeight: "inherit",
                              fontSize: "12px",
                              fontFamily: "inherit",
                            }}
                            options={{
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                            }}
                          ></DateField>
                        </RecordContextProvider>
                      </th>
                    </tr>
                    <tr>
                      <th>No. DO</th>
                      <th>:</th>
                      <th>
                        {
                          props.record.sale_items[0].sale_order_item.sale_order
                            .code
                        }
                      </th>
                    </tr>
                    <tr>
                      <th>Telp/Fax</th>
                      <th>:</th>
                      <th>
                        {props.record.sale_items[0].sale_order_item.sale_order
                          .customer_address.phone
                          ? props.record.sale_items[0].sale_order_item
                            .sale_order.customer_address.phone
                          : "-"}
                        {"/"}
                        {props.record.sale_items[0].sale_order_item.sale_order
                          .customer_address.fax
                          ? props.record.sale_items[0].sale_order_item
                            .sale_order.customer_address.fax
                          : "-"}
                      </th>
                      <th>No. Customer</th>
                      <th>:</th>
                      <th>
                        {
                          props.record.sale_items[0].sale_order_item.sale_order
                            .customer.code
                        }
                      </th>
                    </tr>
                  </thead>
                </table>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    mt: 2,
                    mb: 0.5,
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  SURAT JALAN
                </Typography>
                <table className={`${classes.tableSj} ${classes.salesDeliveryTable}`}>
                  <colgroup>
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "32%" }} />
                    <col style={{ width: "12%" }} />
                    <col style={{ width: "12%" }} />
                    <col style={{ width: "24%" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Kode Barang</th>
                      <th>Nama Barang - Ukuran</th>
                      <th style={{ textAlign: "right" }}>Banyak</th>
                      <th
                        className={classes.beforeNote}
                        style={{ textAlign: "center" }}
                      >
                        Satuan
                      </th>
                      <th className={classes.noteColumn}>Keterangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {arr.map((obj, idx) => {
                      return (
                        <tr key={obj.product.id}>
                          <td>{obj.product.code}</td>
                          <td>{obj.product.name}</td>
                          <td style={{ textAlign: "right" }}>
                            {obj.sent_quantity}
                          </td>
                          <td
                            className={idx === 0 ? classes.beforeNote : undefined}
                            style={{ textAlign: "center" }}
                          >
                            {obj.product.unit}
                          </td>
                          {idx === 0 && (
                            <td
                              className={classes.noteColumn}
                              rowSpan={arr.length}
                            >
                              {props.record.note}
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          textAlign: "right",
                          verticalAlign: "baseline",
                          fontWeight: "bold",
                          borderRight: "none",
                        }}
                      >
                        Total:
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          verticalAlign: "baseline",
                          fontWeight: "bold",
                          borderLeft: "none",
                        }}
                      >
                        {totalMutation}
                      </td>
                      <td colSpan={2}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            fontSize: "10px",
                          }}
                        >
                          <div>Catatan</div>
                          <div>Lembar ke:</div>
                          <div>
                            <Typography variant="inherit">
                              1. Warna Putih untuk Perusahaan
                            </Typography>
                            <Typography variant="inherit">
                              2. Warna Merah untuk Penerima Barang
                            </Typography>
                            <Typography variant="inherit">
                              3. Warna Kuning untuk Angkutan
                            </Typography>
                            <Typography variant="inherit">
                              4. Warna Biru untuk Gudang
                            </Typography>
                            <Typography variant="inherit">
                              5. Warna Hijau untuk Accounting
                            </Typography>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: "8px",
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="inherit" sx={{ mb: 4 }}>
                      Mengetahui
                    </Typography>
                    <Typography>( .............. )</Typography>
                    <Typography variant="inherit">K. DEPO</Typography>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="inherit" sx={{ mb: 4 }}>
                      Pemeriksa
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItem: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <Box sx={{ mr: 1 }}>
                        <Typography>( .............. )</Typography>
                        <Typography variant="inherit">AKUNTING</Typography>
                      </Box>
                      <Box>
                        <Typography>( .............. )</Typography>
                        <Typography variant="inherit">ADMIN</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="inherit" sx={{ mb: 4 }}>
                      Pelaksana
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItem: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <Box sx={{ mr: 1 }}>
                        <Typography>( .............. )</Typography>
                        <Typography variant="inherit">K. GUDANG</Typography>
                      </Box>
                      <Box>
                        <Typography>( .............. )</Typography>
                        <Typography variant="inherit">ANGKUTAN</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography variant="inherit" sx={{ mb: 4 }}>
                      Diterima Oleh
                    </Typography>
                    <Typography>( .............. )</Typography>
                    <Typography variant="inherit">CAP TOKO</Typography>
                  </Box>
                </Box>
                <Typography
                  component="p"
                  variant="caption"
                  sx={{
                    textAlign: "right",
                    mt: 0.5,
                    mb: 0,
                    flexShrink: 0,
                    fontSize: "10px",
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  Dibuat oleh:{" "}
                  <span style={{ textTransform: "uppercase" }}>
                    {props.record.user.first_name +
                      " " +
                      props.record.user.last_name}
                  </span>{" "}
                  <span>
                    <RecordContextProvider value={props.record}>
                      <DateField
                        showTime
                        source="updated_at"
                        sx={{
                          fontWeight: "inherit",
                          fontSize: "11px",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      ></DateField>
                    </RecordContextProvider>
                  </span>
                </Typography>
              </Box>
              <div className="page-break" />
            </Fragment>
          );
        })}
      </Box>
    </Box>
  );
});
export default PrintContent;
